import React from 'react';

import Button from './Button';
import SocialNetworks from './SocialNetworks';
import ConvelioLogo from './ConvelioLogo';
import FormNewsletter from './FormNewsletter';
import DropdownLanguages from './DropdownLanguages';

function Footer({ footer }) {
  const {
    aboutUsTitle,
    legalTitle,
    resourcesTitle,
    usefulLinksTitle,
    companyInfoTitle,
    companyInfo,
    aboutUs,
    resources,
    usefulLinks,
    legal
  } = footer;

  const footerSections = [
    {
      title: companyInfoTitle,
      links: companyInfo
    },
    {
      title: resourcesTitle,
      links: resources
    },
    {
      title: usefulLinksTitle,
      links: usefulLinks
    },
    {
      title: legalTitle,
      links: legal
    },
    {
      title: aboutUsTitle,
      links: aboutUs
    }
  ];
  const FooterInfo = ({ title, links }) => (
    <div className="footer__section">
      {title && <p className="heading-two">{title}</p>}
      {links?.map((button) => (
        <Button
          button={{
            ...button,
            identifier: 'footer',
            additionalClassNames: '--x-small --light'
          }}
          key={button.id}
        />
      ))}
    </div>
  );
  return (
    <>
      <footer
        className="footer --dark"
        id="footer"
        role="contentinfo"
        itemScope
        itemType="http://schema.org/WPFooter"
      >
        <div className="wrapper">
          <ConvelioLogo color="white" additionalClassNames="--large" />
          <div className="footer__container">
            {footerSections?.map(({ title, links }) => (
              <FooterInfo key={title} title={title} links={links} />
            ))}
            <FormNewsletter />
            <div>
              <SocialNetworks />
              <DropdownLanguages />
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
